export function convertPercentageToDecimal(percentage: string) {
  return Number.parseFloat(percentage.replaceAll("%", "")) / 100;
}

export function formatTextResponse(response: string): string {
  let formattedText = response;
  
  // Try to parse as JSON string first
  try {
    formattedText = JSON.parse(response);
  } catch (error) {
    // If parsing fails, use the original response (already set above)
    console.error('Response is not valid JSON, using as plain text:', error);
  }
  
  // Convert escaped newlines to actual newlines and unescape forward slashes
  formattedText = formattedText
    .replaceAll(/\\n/g, '\n')
    .replaceAll(/\\\//g, '/');
  
  return formattedText;
}
